export default __webpack_public_path__ + "static/media/logoSmall.364bb6f0.svg";